<app-navigation-header title="Create Role" [detail]="company?.name" svgName="sl-add">
	@if (company) {
		<div class="mat-stepper-navigator">
			@if (stepperRef.selectedIndex !== 2) {
				<button
					mat-button
					(click)="movePrevious(stepperRef)"
					class="secondary-stepper-button"
					i18n="@@addRoleMainTab-backButton"
					data-automation-id="add-role-back-button"
				>
					Back
				</button>
			}
			@if (stepperRef.selectedIndex !== 2) {
				<button
					mat-flat-button
					[disabled]="!isValid(stepperRef) || serverCallInProgress"
					(click)="moveNext(stepperRef)"
					class="primary-stepper-button"
					i18n="@@addRoleMainTab-continueButton"
					data-automation-id="add-role-continue-button"
				>
					Continue
				</button>
			}
		</div>
	}

	<mat-horizontal-stepper linear #stepperRef>
		<ng-template matStepperIcon="edit">
			<mat-icon>check</mat-icon>
		</ng-template>
		<mat-step>
			<ng-template matStepLabel i18n="@@add-role1/Define">Define</ng-template>
			<!-- Make sure company is loaded before changes -->
			@if (!company) {
				<div
					class="loading-container"
					style="display: flex; align-items: center; justify-content: flex-start; gap: 10px; margin: 20px"
				>
					<mat-spinner diameter="30"></mat-spinner>
					<p i18n="@@addRole-loadingCompany" style="margin: 0; line-height: 1; font-size: 0.875rem">
						Loading company information...
					</p>
				</div>
			}
			@if (company) {
				<app-add-role-define [companyId]="company.id" [editRole]="editRole"> </app-add-role-define>
			}
		</mat-step>

		<mat-step>
			<ng-template matStepLabel i18n="@@add-role2/AddUsers">Add Users</ng-template>
			@if (company) {
				<app-add-role-users [companyId]="company.id" [editRole]="editRole" [requireUsers]="false"> </app-add-role-users>
			}
		</mat-step>

		<mat-step>
			<ng-template matStepLabel i18n="@@add-role3/Confirmation">Confirmation</ng-template>
			@if (company) {
				<app-add-role-confirmation
					[createRoleRequestStatusEvent]="createRoleRequestStatusEvent"
					[companyId]="company.id"
					[isActiveCompany]="isActiveCompany"
				>
				</app-add-role-confirmation>
			}
		</mat-step>
	</mat-horizontal-stepper>
</app-navigation-header>
